import React from 'react';
import PageHeader from './PageHeader';

const HeroIndustrial: React.FC = () => {
  return (
    <section id="inicio">
      <PageHeader
        badge="ISO14001 CERTIFICADO"
        title="INFRAESTRUCTURA SANITARIA"
        titleHighlight="INDUSTRIAL"
        paddingY="medium"
        subtitle="Soluciones robustas y confiables para eventos de gran escala. Tecnología avanzada, operación 24/7 y cumplimiento normativo garantizado."
        buttons={[
          {
            label: 'SOLICITAR PRESUPUESTO A LA MEDIDA',
            href: '#contacto',
            type: 'primary',
            icon: '◉'
          },
          {
            label: 'VER SERVICIOS',
            to: '/servicios',
            type: 'ghost',
            icon: '▦'
          }
        ]}
      >
        <div className="hero-industrial-specs">
          <div className="spec-item">
            <div className="spec-number">500+</div>
            <div className="spec-label">EVENTOS COMPLETADOS</div>
          </div>

          <div className="spec-item">
            <div className="spec-number">24/7</div>
            <div className="spec-label">SOPORTE TÉCNICO</div>
          </div>

          <div className="spec-item">
            <div className="spec-number">99.9%</div>
            <div className="spec-label">UPTIME GARANTIZADO</div>
          </div>

          <div className="spec-item">
            <div className="spec-number">10+</div>
            <div className="spec-label">AÑOS EXPERIENCIA</div>
          </div>
        </div>
      </PageHeader>
    </section>
  );
};

export default HeroIndustrial;